import React from "react";
import { PropTypes } from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateFilter = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  filter,
  text,
}) => {
  return (
    <div className="date-wrapper">
      <p>From:</p>
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        selectsStart
        startDate={startDate}
        endDate={endDate}
      />
      <br />
      <br />
      <p>To:</p>
      <DatePicker
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
      />
      <br />
      <div onClick={filter}>
        <button className="date-btn">{text}</button>
      </div>
    </div>
  );
};

DateFilter.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
  filter: PropTypes.func,
  text: PropTypes.string,
};
export default DateFilter;
